export const LaundryIcon = () => (
  <svg width="44" height="56" viewBox="0 0 44 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.599609 9.63184V50.232C0.599609 51.6057 1.71126 52.7173 3.08493 52.7173H40.7094C42.0831 52.7173 43.1947 51.6057 43.1947 50.232V9.63184H0.603333H0.599609Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M38.8229 0.599609H4.96766C2.55344 0.599609 0.599609 2.55345 0.599609 4.96767V9.63518H43.191V4.96767C43.191 2.55345 41.2371 0.599609 38.8229 0.599609Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M43.191 46.7129H0.599609"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.37109 53.7313C6.37109 54.2104 6.76037 54.5997 7.23947 54.5997H10.4397C10.9188 54.5997 11.3081 54.2104 11.3081 53.7313V52.7207H6.37484V53.7313H6.37109Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M32.4863 52.7207V53.7313C32.4863 54.2104 32.8756 54.5997 33.3547 54.5997H36.5549C37.034 54.5997 37.4233 54.2104 37.4233 53.7313V52.7207H32.4901H32.4863Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.9863 30.199C11.5103 30.199 11.9557 30.2739 12.3488 30.3899C13.2433 30.6519 13.8609 31.1535 14.4598 31.6438C15.3544 32.3737 16.2003 33.0699 17.9296 33.0549C19.6551 33.0437 21.3993 31.5802 21.4068 31.5727C22.2677 30.8503 23.1622 30.1167 24.9214 30.1055H24.9664C26.7181 30.1055 27.6164 30.8391 28.4847 31.5465C29.0799 32.0331 29.6526 32.4972 30.476 32.7555C30.884 32.8828 31.3519 32.9576 31.9096 32.9576"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.893 42.1356C29.6036 42.1356 35.8543 35.8849 35.8543 28.1742C35.8543 20.4636 29.6036 14.2129 21.893 14.2129C14.1823 14.2129 7.93164 20.4636 7.93164 28.1742C7.93164 35.8849 14.1823 42.1356 21.893 42.1356Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.893 39.2685C28.0202 39.2685 32.9872 34.3015 32.9872 28.1743C32.9872 22.0471 28.0202 17.0801 21.893 17.0801C15.7659 17.0801 10.7988 22.0471 10.7988 28.1743C10.7988 34.3015 15.7659 39.2685 21.893 39.2685Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.6846 5.21094H0.603516"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.7414 0.599609L14.6852 5.21097L14.6328 9.63144"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M31.2391 6.49869C31.9212 6.49869 32.4743 5.94568 32.4743 5.26351C32.4743 4.58133 31.9212 4.02832 31.2391 4.02832C30.5569 4.02832 30.0039 4.58133 30.0039 5.26351C30.0039 5.94568 30.5569 6.49869 31.2391 6.49869Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M36.1199 6.49869C36.8021 6.49869 37.3551 5.94568 37.3551 5.26351C37.3551 4.58133 36.8021 4.02832 36.1199 4.02832C35.4377 4.02832 34.8848 4.58133 34.8848 5.26351C34.8848 5.94568 35.4377 6.49869 36.1199 6.49869Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.4188 6.49869C27.1009 6.49869 27.654 5.94568 27.654 5.26351C27.654 4.58133 27.1009 4.02832 26.4188 4.02832C25.7366 4.02832 25.1836 4.58133 25.1836 5.26351C25.1836 5.94568 25.7366 6.49869 26.4188 6.49869Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
